import { FormProvider } from "react-hook-form";

import FormInputs from "@/components/Organisms/HookFormInputs/V1";
import Typography from "@/foundation/Typography/V2";

import useTrialCallbackForm from "./useTrialCallbackForm";
import BookSlotFormWrapper from "../../../BookSlotFormWrapper";

import { classNameGenerator } from "@/utils";

import styles from "./TrialCallbackForm.module.scss";

interface TrialCallbackFormProps {
  setIsFormSubmitted?: (isFormSubmitted: boolean) => void;
}

const TrialCallbackForm: React.FC<TrialCallbackFormProps> = ({
  setIsFormSubmitted,
}) => {
  const cls = classNameGenerator(styles);

  const { methods, isLoading, onBlur, requestCallbackHandler } =
    useTrialCallbackForm({
      setIsFormSubmitted,
    });

  const components = [
    {
      name: "name",
      props: {
        name: "name",
        className: cls("name"),
      },
    },
    {
      name: "phone",
      props: {
        name: "mobile",
        className: cls("phone"),
        onBlur,
      },
    },
    {
      props: {
        children: (
          <Typography variant="paragraph1" className={cls("preferredMedium")}>
            Let us know your preferred medium.
          </Typography>
        ),
      },
    },
    {
      name: "radioGroup",
      props: {
        name: "preferredContactMedium",
        className: cls("contactRadio"),
        fields: [
          {
            value: "call",
            label: "Call",
          },
          {
            value: "whatsapp",
            label: "WhatsApp",
          },
        ],
      },
    },
    {
      name: "submit",
      props: {
        children: (
          <Typography
            variant="span"
            dangerouslySetInnerHTML={{
              __html: "Submit details",
            }}
          />
        ),
        className: cls("submitButton"),
        isLoading,
      },
    },
  ];

  return (
    <div className={cls("trialCallbackForm")}>
      <div className={cls("TrialCallbackFormWrapper")}>
        <BookSlotFormWrapper
          title="Speak to our team!"
          subtitle="Not getting a suitable slot? Or want to understand more about our Yoga Classes. Our team can help."
        >
          <FormProvider {...methods}>
            <form
              className={cls("formWrapper")}
              onSubmit={requestCallbackHandler}
            >
              <FormInputs components={components} />
            </form>
          </FormProvider>
        </BookSlotFormWrapper>
      </div>
    </div>
  );
};

export default TrialCallbackForm;
